import {Schema} from "effect";

export {StarWriteError, StarAuthError, StarWriteOperation} from "./errors.js";
export type {StarError} from "./errors.js";

/**
 * Firestore collection backing document stars. Reads are client-side
 * `onSnapshot` subscriptions; writes go through the accounts-app HTTP endpoint.
 */
export const STARRED_COLLECTION = "starredDocuments";

/** Deterministic doc id for a (document, user) pair. Must match `createStarredDocumentUid`. */
export function starredDocId(documentUid: string, userUid: string): string {
    return `${documentUid}:${userUid}`;
}

export const StarState = Schema.Literal("star", "unstar");
export type StarState = typeof StarState.Type;

export class StarRequest extends Schema.Class<StarRequest>("StarRequest")({
    state: StarState,
    documentUid: Schema.String,
}) {}

export class StarResponse extends Schema.Class<StarResponse>("StarResponse")({
    starred: Schema.Boolean,
}) {}
